module.exports = __webpack_public_path__ + "static/dev-flow-801a400990a3efcb8a003020b1f43803.png";